import {gql} from 'graphql-request'

export const THEME_FRAGMENT = gql`
    fragment ThemeFragment on Theme {
        backgroundColor
        color
    }
`
